import {Sections} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {NavButton} from '~/common/fabric/CreateDesign/components/NavBottom/NavButton';
import {PostStampIcon} from '~library/svg/PostStampIcon';
import {DiagonalLinesIcon} from '~library/svg/v2/DiagonalLinesIcon';
import {DocumentIcon} from '~library/svg/v2/DocumentIcon';
import {MailIcon} from '~library/svg/v2/MailIcon';
import {charcoal} from '~libSass/base/_exports.sass';

export const CardFeaturesPanel = () => (
  <>
    <NavButton
      title="Card design"
      icon={<DocumentIcon color={charcoal} ratio={0.75} />}
      section={Sections.CARD_DESIGN}
      disableAutoOpenEditor
    />
    <NavButton
      title="Envelope & liner"
      icon={<MailIcon color={charcoal} ratio={0.75} />}
      section={Sections.ENVELOPE_LINER}
    />
    <NavButton
      title="Stamp & stickers"
      icon={<PostStampIcon color={charcoal} />}
      section={Sections.STAMP}
    />
    <NavButton
      title="Background"
      icon={<DiagonalLinesIcon color={charcoal} ratio={0.594} />}
      section={Sections.BACKGROUND}
    />
  </>
);
